import React from 'react';
import { TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';

type VolumeFieldProps = {
    value: string;
    handleChange: (newValue: string) => void;
    required: boolean;
    errorText: string;
    disabled?: boolean;
    marginLeft: string;
    label: string;
    autofocus: boolean;
};

export default function VolumeField(props: VolumeFieldProps) {
    const [hasBlurred, setHasBlurred] = React.useState(false);
    let volumeErrorText: string = "";
    if (hasBlurred) {
        if (props.errorText !== "") {
            volumeErrorText = props.errorText;
        } else if (!props.value && props.required) {
            volumeErrorText = 'Volume is Required';
        }
    }
    return (
        <TextField
            required={props.required}
            disabled={props.disabled}
            autoFocus={props.autofocus}
            error={volumeErrorText !== ''}
            style={{ verticalAlign: 'bottom', minHeight: '5rem', marginLeft: props.marginLeft }}
            label={props.label}
            value={props.value}
            onChange={event => {
                props.handleChange(event.target.value);
            }}
            helperText={volumeErrorText}
            name="numberformat"
            InputProps={{
                inputComponent: NumberFormatCustom as any
            }}
            onBlur={() => {
                setHasBlurred(true);
            }}
        />
    );
}

interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat | null) => void;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator
            isNumericString
            inputMode={'text'}
        />
    );
}
